import styled from "styled-components";
import { Link } from "react-router-dom";
import { CommmonBox, CommonBoxTitle, CommonLayout, LinkTd, MailYesNoTd } from "../style/common";
import { 
  flexAroundCenter,
  flexBetweenEnd,
  flexCenterCenter,
  flexColumnCenter,
  flexUnsetCenter
} from "../style/mixins";
import { ReactComponent as DashboardSec1OneIcon } from '../svgs/dashboard_sec1_1_icon.svg';
import { ReactComponent as DashboardSec1TwoIcon } from '../svgs/dashboard_sec1_2_icon.svg';
import { theme } from "../theme";
import Table from "../components/common/Table";
import { materialTheadArr } from "../constants/TheadConst";
import PdfBtn from "../components/common/pdfBtn";
import Mp3Btn from "../components/common/mp3Btn";
import { gnbConst } from "../constants/gnbConst";
import { useEffect, useState } from "react";
import useFormattedDate from "../hooks/useFormattedDate";
import { statsNum } from "../api/stats";
import moment from "moment";
import { contentsList } from "../api/contents";
import { dateHyphen } from "../utils/dateFormChange";
import { stringToJson } from "../utils/stringToJson";
import { useNavigatePage } from "../hooks/useNavigatePage";
import { isFilePath } from "../utils/isFilePath";
import { mailSendText } from "../utils/mailSendText";
import { useMemberStore } from "../store/memberStore";

export default function Dashboard() {
  const { onMovementPage } = useNavigatePage();
  const { memberPermitLevel } = useMemberStore();
  const toDay = useFormattedDate({});
  const [totalUse, setTotalUse] = useState(0);
  const [todayUse, setTodayUse] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [weekUsers, setWeekUsers] = useState(0);
  const [cancelUser, setCancelUser] = useState(0);
  const [noticeListData, setNoticeListData] = useState<ListGetApiResponse>();
  const [meterialListData, setMeterialListData] = useState<ListGetApiResponse>();

  const onClickGoDetail = (idx: string) => {
    onMovementPage("/material/detail/" + idx);
  };

  useEffect(() => {
    if (gnbConst[0].level > memberPermitLevel) {
      alert("접근 권한이 없습니다.");
      onMovementPage(-1);
    }
  }, [memberPermitLevel]);

  useEffect(() => {
    const fetchUserStats = async () => {
      const params = {
        stats_date_end: toDay.replaceAll("-", "") + "24",
      }
      
      try {
        const totalUseParams = {
          ...params,
          target_idx: process.env.REACT_APP_TBM_MODULE_IDX as string,
          stats_date_start: "2025010100",
          stats_idx: process.env.REACT_APP_STATS_IDX_CONTENT_USE as string
        };

        const todayUseParmas = {
          ...params,
          target_idx: process.env.REACT_APP_TBM_MODULE_IDX as string,
          stats_date_start: toDay.replaceAll("-", "") + "00",
          stats_idx: process.env.REACT_APP_STATS_IDX_CONTENT_USE as string
        }

        const totalUsersParams = {
          ...params,
          stats_date_start: "2025010100",
          stats_idx: process.env.REACT_APP_STATS_IDX_ALL_URE as string
        };

        const weekUsersParams = {
          ...params,
          stats_date_start: moment().subtract(7, 'days').format('YYYYMMDDHH'),
          stats_idx: process.env.REACT_APP_STATS_IDX_ALL_URE as string
        };

        const cancelUserParams = {
          ...params,
          stats_date_start: "2025010100",
          stats_idx: process.env.REACT_APP_STATS_IDX_CANCEL_USE as string
        };

        const itemDataParams = {
          page_index: 1,
          page_size: 5,
        }

        const meterialListParams = {
          ...params,
          ...itemDataParams,
          create_date_start: "2025010100",
          task_load: 1,
        }

        const [
          totalUseResponse,
          todayUseResponse,
          totalUsersResponse,
          weekUsersResponse,
          cancelUserResponse,
          noticeListResponse,
          meterialListResponse,
        ] = await Promise.all([
          statsNum(totalUseParams),
          statsNum(todayUseParmas),
          statsNum(totalUsersParams),
          statsNum(weekUsersParams),
          statsNum(cancelUserParams),
          contentsList(itemDataParams, "notice"),
          contentsList(meterialListParams, "material"),
        ]);

        setTotalUse(totalUseResponse.data.value || 0);
        setTodayUse(todayUseResponse.data.value || 0);
        setTotalUsers(totalUsersResponse.data.value || 0);
        setWeekUsers(weekUsersResponse.data.value || 0);
        setCancelUser(cancelUserResponse.data.value || 0);
        setNoticeListData(noticeListResponse);
        setMeterialListData(meterialListResponse);
      }
      catch (error: any) {
      }
    }
    
    fetchUserStats();
  }, [toDay]);

  return (
    <DashboardLayout>
      <DashboardGridBox1>
        <DashboardGridBox2>
          <Dashboard1>
            <Dashboard1Item>
              <CircleBox $bgc="#FFD02E">
                <DashboardSec1OneIcon />
              </CircleBox>
              <div>
                <ItemTitle>총사용량</ItemTitle>
                <ItemContent>{totalUse.toLocaleString()}</ItemContent>
              </div>
            </Dashboard1Item>

            <Dashboard1Item>
              <CircleBox $bgc="#0DBBEF">
                <DashboardSec1TwoIcon />
              </CircleBox>
              <div>
                <ItemTitle>일일사용량</ItemTitle>
                <ItemContent>{todayUse.toLocaleString()}</ItemContent>
              </div>
            </Dashboard1Item>
          </Dashboard1>

          <Dashboard2>
            <div>
              <ItemTitle>전체회원수</ItemTitle>
              <ItemContent>{totalUsers.toLocaleString()}</ItemContent>
            </div>

            <div></div>

            <div>
              <ItemTitle>신규회원수 (일주일)</ItemTitle>
              <ItemContent>{weekUsers.toLocaleString()}</ItemContent>
            </div>

            <div></div>

            <div>
              <ItemTitle>탈퇴회원수</ItemTitle>
              <ItemContent>{cancelUser.toLocaleString()}</ItemContent>
            </div>
          </Dashboard2>
        </DashboardGridBox2>

        <CommmonBox>
          <DashoardTitle>
            공지사항
            <Link to={gnbConst[2].path}>더보기</Link>
          </DashoardTitle>

          <NoticeList>
            {noticeListData && (
              noticeListData.list.map((obj, i) => (
                <NoticeListItem key={i} to={"/notice/detail/" + obj.idx}>
                  <h6>{obj.title ? obj.title : "-"}</h6>
                  <NoticeListItemInfo>
                    <p>{obj.member?.member_name ? obj.member.member_name : "-"}</p>
                    <div></div>
                    <p>{obj.date_active ? dateHyphen(obj.date_active, "YYYY-MM-DD") : "-"}</p>
                  </NoticeListItemInfo>
                </NoticeListItem>
              ))
            )}
          </NoticeList>
        </CommmonBox>
      </DashboardGridBox1>

      <CommmonBox>
        <DashoardTitle>
          최근 TBM
          <Link to={gnbConst[3].path}>더보기</Link>
        </DashoardTitle>

        <Table thead={materialTheadArr}>
          {meterialListData && meterialListData.list.map(obj => {
            const mailTask = obj.task?.find(t => t.task_idx === process.env.REACT_APP_MAIL_TASK_IDX);
            return (
            <tr key={obj.idx}>
              {/* <td><input type="checkbox" /></td> */}
              <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.date_update ? dateHyphen(obj.date_update, "YYYY-MM-DD") : "-"}</LinkTd>
              <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.member?.member_id ? obj.member.member_id : "-"}</LinkTd>
              <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.member?.member_name ? obj.member.member_name : "-"}</LinkTd>
              <LinkTd onClick={() => onClickGoDetail(obj.idx)}>
                {obj.member?.member_public_extras ? stringToJson(obj.member.member_public_extras).com : "-"}
              </LinkTd>
              <LinkTd onClick={() => onClickGoDetail(obj.idx)}>
                {obj.member?.member_public_extras ? stringToJson(obj.member.member_public_extras).sub : "-"}
              </LinkTd>
              <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.title}</LinkTd>
              <td>
                {obj.files && obj.files.length > 0 ? (
                  isFilePath(obj.files, "pdf").length > 0 ? (
                    <PdfBtn
                      path={isFilePath(obj.files, "pdf")[0].file_url as string}
                      fileName={isFilePath(obj.files, "pdf")[0].file_name_origin as string}
                    />
                  ) : "-"
                ) : "-"}
              </td>
              <td>
                {obj.files && obj.files.length > 0 ? (
                  isFilePath(obj.files, "m4a").length > 0 ? (
                    <Mp3Btn 
                      path={isFilePath(obj.files, "m4a")[0].file_url as string}
                      fileName={isFilePath(obj.files, "m4a")[0].file_name_origin as string}
                    />
                  ) : "-"
                ) : "-"}
              </td>
              <MailYesNoTd
                $mail={mailTask?.task_state ?? undefined}>
                  {mailTask ? mailSendText(mailTask.task_state as number) : "실패"}
                </MailYesNoTd>
            </tr>
            );
          })}
        </Table>
      </CommmonBox>
    </DashboardLayout>
  );
}

const DashboardLayout = styled(CommonLayout)`
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 1.5rem;
`;

const DashboardGridBox1 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
`;

const DashboardGridBox2 = styled.div`
  display: grid;
  grid-template-rows: 5fr 4fr;
  grid-template-columns: 1fr;
  gap: 1.5rem;
`;

const Dashboard1 = styled(CommmonBox)`
  ${flexAroundCenter};
`;

const Dashboard1Item = styled.div`
  ${flexUnsetCenter};
  gap: 1.875rem;
`;

const Dashboard2 = styled(CommmonBox)`
  display: grid;
  grid-template-columns: 1fr 1px 1fr 1px 1fr;

  div {
    ${flexColumnCenter};
  }

  div:nth-child(odd) {
    padding-left: 2.375rem;
  }

  div:nth-child(even) {
    background-color: #D7D7D7;
  }

  div:first-child {
    padding-left: 1rem;
  }
`;

const ItemTitle = styled.h5`
  color: ${theme.color.secondary};
  font-size: 1.125rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
`;

const ItemContent = styled.p`
  font-size: 2rem;
  font-weight: 900;
`;

const CircleBox = styled.div<{ $bgc: string; }>`
  background-color: ${({ $bgc }) => $bgc};
  width: 92px;
  height: 92px;
  border-radius: 50%;
  ${flexCenterCenter};
`; 

const DashoardTitle = styled(CommonBoxTitle)`
  ${flexBetweenEnd};
  padding: 0;
  border: none;

  a {
    color: #999;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1;
  }
`;

const NoticeList = styled.div`
  border-top: 1px solid #E6E9ED;
`;

const NoticeListItem = styled(Link)`
  padding: 1.125rem 0.625rem;
  border-bottom: 1px solid #F5F5F5;
  display: grid;
  grid-template-columns: calc(100% - 156px) 150px;

  > h6 {
    color: #666;
    font-size: 1.125rem;
    font-weight: 400;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    > h6 {
      color: ${theme.color.primary};
    }
  }
`;

const NoticeListItemInfo = styled.div`
  ${flexCenterCenter};
  gap: 0.875rem;

  p {
    color: #73879C;
    font-size: 0.875rem;
  }

  div {
    background-color: #DDDEE0;
    width: 1px;
    height: 10px;
  }
`;